module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"commentsFailed":"Failed to load comments","comments":"Comments"},"ar":{"commentsFailed":"خطأ اثناء تحميل التعليقات","comments":"التعليقات"}}')
  delete Component.options._Ctor
}
